import {
  MessageActionTypes,
  MessageType,
  sendMessageAction as sendMessageActionToServer,
} from '@weblite/ts-action/message'
import throttle from 'lodash.throttle'
import { send } from '$setup/ws'
import { getRoom } from '$logic/room'
import { RECEIVE_ACTION_TIME_OUT } from './events'

export async function sendMessageAction(
  action: MessageActionTypes,
  roomId: string,
) {
  const room = await getRoom(roomId)
  if (!room) return
  if (room.type === 'PV' || room.type === 'GROUP')
    send(sendMessageActionToServer({ action, roomId }))
}

export const onSendingMessageAction = throttle(
  (roomId: string, event: MessageActionTypes) =>
    sendMessageAction(event, roomId),
  RECEIVE_ACTION_TIME_OUT,
  {
    trailing: false,
  },
)

export const messageTypeToSendingMessageAction: Record<
  MessageType,
  MessageActionTypes
> = {
  EVENT: undefined,
  WAPP: undefined,
  AUDIO: 'UPLOAD_AUDIO',
  VIDEO: 'UPLOAD_VIDEO',
  FILE: 'UPLOAD_FILE',
  IMAGE: 'UPLOAD_PHOTO',
  VOICE: 'UPLOAD_VOICE',
  TEXT: 'TYPING',
}
